require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.string.starts-with");

var visit = require('unist-util-visit');

var commentOpen = '<!--';
var commentClose = '-->';

module.exports = function (_options) {
  return function (tree) {
    visit(tree, 'html', function (node) {
      if (node.value.startsWith(commentOpen) && node.value.endsWith(commentClose)) {
        node.type = 'comment';
        node.value = node.value.slice(commentOpen.length, -commentClose.length);
      } else {
        node.type = node.mdxType || 'jsx';
      }
    });
    return tree;
  };
};